export enum FuelType {
    Petrol = 1, Disel, Electric, Hybrid
}